import type { ApiSearchQuery } from "@/lib/api/api-type-helper";
import type { EnumUnion } from "@dresscode-frontend/utility-types";

type IdManagementQuery = ApiSearchQuery<"/v2/id-management/ids", "get">;

export const IdManagementCategory = {
  ALL: "ALL",
  PERSONAL_ID: "PERSONAL_ID",
  EMPLOYEE_ID: "EMPLOYEE_ID",
  BOARD_MEMBER_ID: "BOARD_MEMBER_ID",
  CONTRACTOR_ID: "CONTRACTOR_ID",
  COLLABORATOR_ID: "COLLABORATOR_ID",
  UNKNOWN_ID: "UNKNOWN_ID",
} as const satisfies Record<NonNullable<IdManagementQuery["category"]>, string>;
export type IdManagementCategory = EnumUnion<typeof IdManagementCategory>;

export const IdManagementStatus = {
  GROUP_ID: "GROUP_ID",
  EMPLOYEE_ID: "EMPLOYEE_ID",
  PERSONAL_ID: "PERSONAL_ID",
  CONTRACTOR_ID: "CONTRACTOR_ID",
  COLLABORATOR_ID: "COLLABORATOR_ID",
};

export type IdManagementStatus = EnumUnion<typeof IdManagementStatus>;
